import { Helmet } from "react-helmet-async"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../Auth"
import { HotelOperationalCalendar } from "../../../HotelBookings"
export default function HotelSchedulesCalendarModule() {
	return (
		<>
			<Helmet>
				<title>Hotel Operational Calendar</title>
			</Helmet>
			<ForbidUnlessAuthorized permission={PERMISSIONS.VIEW_HOTEL_BOOKINGS}>
				<HotelOperationalCalendar />
			</ForbidUnlessAuthorized>
		</>
	)
}
